export const OrderReducer = (state, action) => {

    switch (action.type) {
        
        case 'ADD_ITEM': {
            return {
                status: state.status,
                bebidas: [...state.bebidas, action.payload],
                tipo: state.tipo,
                user: state.user,
                total: action.total,
                direccion: state.direccion
            }
        }

        case 'CONFIRM_ORDER': {
            return {
                status: action.payload,
                bebidas: state.bebidas,
                tipo: state.tipo,
                user: action.user,
                total: action.total,
                direccion: state.direccion
            }
        }

        case 'REMOVE_ITEM': {

            let beb = state.bebidas
            beb.splice(state.bebidas.indexOf(action.payload), 1)

            return {
                status: state.status,
                bebidas: beb,
                tipo: state.tipo,
                user: state.user,
                total: state.total,
                direccion: state.direccion
            }

        }

        case 'ORDER_TYPE':

            return {

                status: state.status,
                bebidas: state.bebidas,
                tipo: action.payload,
                user: state.user,
                total: state.total,
                direccion: state.direccion
            }

        default: return state
    }
}